var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui grid container"},[_c('br'),_c('h2',{staticClass:"ui header"},[_vm._v(_vm._s(_vm.$t('preview.overview.calculated_taxes.title')))]),_c('div',{staticClass:"one column row"},[_c('ListadoObligaciones',{attrs:{"columns":_vm.obligationsColumns,"obligations":_vm.mapTaxesTableData()}})],1),_c('sui-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }